import axios from "axios";
import {GET_CERTS, GET_CLEARANCES, GET_DEGREES, GET_EXP_LVLS, GET_SKILL_TYPES, GET_SKILLS} from "./RestCatalog";

const getCerts = () => {
    return axios.get(GET_CERTS)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getClearances = () => {
    return axios.get(GET_CLEARANCES)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getDegrees = () => {
    return axios.get(GET_DEGREES)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getSkills = () => {
    return axios.get(GET_SKILLS)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getSkillTypes = () => {
    return axios.get(GET_SKILL_TYPES)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getExpLvls = () => {
    return axios.get(GET_EXP_LVLS)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}


export { getCerts, getClearances, getDegrees, getSkills, getSkillTypes, getExpLvls };